module.exports = __webpack_public_path__ + "assets/img/Cancel_btn.2ea071e1.png";